// extracted by mini-css-extract-plugin
module.exports = {"search":"S_dg","input":"S_b6","search-icon":"S_dh","searchIcon":"S_dh"};